import { render } from "./form-pc.vue?vue&type=template&id=13aecccb&ts=true"
import script from "./form-pc.vue?vue&type=script&lang=ts"
export * from "./form-pc.vue?vue&type=script&lang=ts"

import "./form-pc.vue?vue&type=style&index=0&id=13aecccb&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__